// Anemoia SOLAR/LUNAR mode toggle (custom).
// Pairs with snippets/anemoia-color-mode.liquid (pre-paint script + scheme remap)
// and snippets/anemoia-mode-toggle.liquid (markup).

const MODE_KEY = 'anemoia:mode';
const MODE_EVENT = 'anemoia:mode-change';

class AnemoiaModeToggle extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('button');
    if (!this.button) return;
    this.button.addEventListener('click', this.toggle);
    document.addEventListener(MODE_EVENT, this.sync);
    this.sync();
  }

  disconnectedCallback() {
    document.removeEventListener(MODE_EVENT, this.sync);
  }

  toggle = () => {
    const html = document.documentElement;
    const next = html.getAttribute('data-anemoia-mode') === 'lunar' ? 'solar' : 'lunar';

    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      html.classList.add('anemoia-mode-transition');
      clearTimeout(this.transitionTimeout);
      this.transitionTimeout = setTimeout(() => html.classList.remove('anemoia-mode-transition'), 600);
    }

    html.setAttribute('data-anemoia-mode', next);
    try {
      window.localStorage.setItem(MODE_KEY, next);
    } catch (error) {
      // Storage unavailable (private mode); the choice just won't persist.
    }
    document.dispatchEvent(new CustomEvent(MODE_EVENT));
  };

  sync = () => {
    const lunar = document.documentElement.getAttribute('data-anemoia-mode') === 'lunar';
    this.button.setAttribute('aria-pressed', String(lunar));
  };
}

if (!customElements.get('anemoia-mode-toggle')) {
  customElements.define('anemoia-mode-toggle', AnemoiaModeToggle);
}
